import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Buscás actividades en Pinterest y encontrás cosas que necesitan materiales que no tenés', 'No sabés si tu hijo está dentro de los hitos normales para su edad o necesita una consulta', 'Llegás al pediatra sin saber qué preguntar y salís con más dudas que respuestas', 'Querés jugar y estimular pero terminás dándole el celular porque no sabés qué hacer', 'Los berrinches te superan y no entendés qué está pasando en su cabeza', 'Sentís que otros nenes avanzan más rápido y empezás a comparar', 'Cada etapa nueva te genera la misma pregunta: ¿qué se supone que tengo que hacer ahora?'];
  return <section className="py-20 bg-sky-950" data-id="element-232">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-234">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-235">
            ¿Cuántas veces más vas a improvisar con tu hijo sin saber si lo
            estás estimulando bien?
          </h2>

          <div className="space-y-6 text-lg text-sky-100 text-left md:text-center max-w-3xl mx-auto" data-id="element-236">
            <p className="text-[14px]" data-id="element-237">
              Querés darle lo mejor. Tal vez tu bebé no alcanzó un hito y no
              sabés si preocuparte. Tal vez tu nene de 3 años tiene berrinches
              que no entendés. Tal vez tu hija está por entrar al jardín y
              sentís que le falta algo pero no sabés qué.
            </p>
            <p data-id="element-238">
              <strong className="text-white text-[16px]" data-id="element-239">
                Pero nadie te dijo que entender el desarrollo infantil desde
                adentro iba a ser tan difícil.
              </strong>
            </p>
            <p className="text-[14px]" data-id="element-240">
              Buscás en Google y encontrás información contradictoria que te
              genera más angustia. Seguís videos en inglés que no aplican al
              contexto argentino. Comprás libros que son pura teoría sin
              actividades concretas. Y seguís llegando al día a día con la
              sensación de que "algo le falta" o de que "podría estar haciendo
              más."
            </p>
            <p className="font-bold text-white pt-4 text-[14px]" data-id="element-241">
              No es falta de amor. Es falta de un sistema.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-red-950/40 border border-red-900/60 rounded-2xl p-6 md:p-8" data-id="element-242">
          <ul className="space-y-4" data-id="element-243">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-244">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-245">
                  <X className="w-4 h-4 text-red-400" data-id="element-246" />
                </div>
                <span className="text-sky-50 font-medium text-[14px]" data-id="element-247">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-248">
          <p className="font-bold text-sky-300 text-[16px]" data-id="element-249">
            ¿Y si este fuera el último día que criás sin un sistema que te guíe
            paso a paso?
          </p>
        </div>
      </div>
    </section>;
}